// This function allow to reference chunks
__webpack_require__.u = (chunkId) => {
  // return url for filenames not based on template
  
  // return url for filenames based on template
  return "" + chunkId + "." + {"6814": "356545b2ce32de3b","7173": "52e4b71cbc1d9623",}[chunkId] + ".chunk.js"
}